import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { NotifactionService } from '../services/notification.service';
// import { AuthTokenService } from '../services/authToken.service';
import { environment } from '../../../environments/environment';

export const globalHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notification = inject(NotifactionService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const currentUrl = encodeURIComponent(window.location.href);
        window.location.href = `${environment.authUrl}/login?redirect=${currentUrl}`;
      }
      if (error.status === 0) {
        notification.error('NETWORK_ERROR', error.message, error.status.toString());
      }

      if (error.status >= 500) {
        notification.error('Error', error.message, error.status.toString());
      }

      if (error.status === 400 || error.status === 422) {
        const message = error.error?.message || 'Request failed';
        notification.error('Error', message, error.status.toString());
      }

      return throwError(() => error);
    }),
  );
};
